export default __webpack_public_path__ + "static/media/Connect_icon.2dc9e357.svg";